"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMiddleware = void 0;
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
const requests_1 = require("../requests");
const routes_1 = require("../routes");
const Loading_1 = require("../components/Loading/Loading");
/* eslint-disable react/jsx-props-no-spreading */
exports.authMiddleware = (WrapperComponent) => class AuthMiddleware extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            redirect: '',
            authenticatedUser: {},
        };
    }
    componentDidMount() {
        let localAccessToken;
        return config_1.getAccessInformation()
            .then(({ accessToken, userId }) => {
            localAccessToken = accessToken;
            return requests_1.validateTokenRequest(userId, accessToken);
        })
            .then((r) => this.setState({ authenticatedUser: r.data }))
            .then(() => {
            axios_1.default.defaults.headers.common.Authorization = localAccessToken;
            this.setState({ loading: false });
        })
            .catch(() => {
            config_1.destroyAccessInformation().then(() => this.setState({ redirect: routes_1.routes.LOGIN }));
        });
    }
    render() {
        const { loading, redirect, authenticatedUser } = this.state;
        if (redirect)
            return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
        if (loading)
            return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
        return react_1.default.createElement(WrapperComponent, Object.assign({}, this.props, { authenticatedUser: authenticatedUser }));
    }
};
//# sourceMappingURL=auth-middleware.js.map